// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3W7nI","select":"Header_select__dLTjR","clinic":"Header_clinic__1cBkP"};